class QuickViewDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('close', () => {
        const drawerContent = this.querySelector('.quick-view__content');
        drawerContent.innerHTML = '';
        drawerContent.classList.remove('hide-cover');

        document.dispatchEvent(new CustomEvent('quickview:close'));
      });
    }
  }
  customElements.define('quick-view-drawer', QuickViewDrawer);

  class QuickViewButton extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        if (event.target.closest('.card-quick-view') || event.target.closest('.product-slide-caption')) event.preventDefault()

        // Show loading spinner
        const card = this.closest('.card-container') || this.closest('.card');
        if (card) {
          // Product card: overlay on entire card
          card.classList.add('qv-card-loading');
          this._loadingEl = card;
        } else {
          // Other buttons (pick-by-stars etc): spinner on button
          const btn = this.querySelector('button') || this;
          btn.classList.add('qv-btn-loading');
          this._loadingEl = btn;
        }

        this.closest('body').classList.add('hidden', 'quick-view-open')
        const drawer = document.querySelector('quick-view-drawer');
        if (drawer) {
          drawer.querySelector('quick-view').setAttribute('data-product-url', `${this.dataset.productVariantUrl}`)
          drawer.querySelector('summary').click();
          document.dispatchEvent(new CustomEvent('quickview:open', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }
        else if (this.dataset.productUrl) {
          window.location = this.dataset.productUrl;
        }
      });

      // Remove loading spinner when quick view content loads or closes
      const removeLoading = () => {
        if (this._loadingEl) {
          this._loadingEl.classList.remove('qv-card-loading', 'qv-btn-loading');
          this._loadingEl = null;
        }
      };
      document.addEventListener('quickview:loaded', removeLoading);
      document.addEventListener('quickview:close', removeLoading);
      this.quickButton = this.querySelector('.quick') || this.closest('.quick');
      const cardExtras = this.quickButton?.closest?.('.card__extras');
      if (this.quickButton && cardExtras) {
        this.quickButton.addEventListener('focus', () => {
          cardExtras.style.bottom = '8px';
        });
        this.quickButton.addEventListener('blur', () => {
          cardExtras.style.bottom = '-54px';
        });
        this.quickButton.addEventListener('quickview:open', () => {
          cardExtras.style.bottom = '-54px';
        });
      }
    }
  }
  customElements.define('quick-view-button', QuickViewButton);

  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.overlay = document.querySelector('body > .overlay')
      this.quickModal = this.querySelector('.popup-wrapper')
      this.closeButton = this.querySelector('.qv-modal-close') || this.querySelector('.button-close');
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.popup-wrapper') || event.target.closest('.button-close') || event.target.closest('.qv-modal-close') || event.target.closest('.close-popup')) this.closeQuickView()
      })
      document.addEventListener('keyup', (event) => {
        if (!this.querySelector('.popup-wrapper.open')) return;
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.closeQuickView();
        } else if (event.code === 'ArrowRight') {
          const nextBtn = this.querySelector('.qv-carousel__arrow--next');
          if (nextBtn) nextBtn.click();
        } else if (event.code === 'ArrowLeft') {
          const prevBtn = this.querySelector('.qv-carousel__arrow--prev');
          if (prevBtn) prevBtn.click();
        }
      });
      document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(e) {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;
      const mediaMapEl = this.querySelector('[id^="qv-variant-media-map-"]');
      const qvCarousel = this.querySelector('.qv-carousel');
      if (!mediaMapEl || !qvCarousel) return;

      try {
        const map = JSON.parse(mediaMapEl.textContent);
        const variantData = map[variant.id];
        if (variantData && variantData.media_id) {
          const targetSlide = qvCarousel.querySelector(`[data-media-id="${variantData.media_id}"]`);
          const track = qvCarousel.querySelector('.qv-carousel__track');
          if (targetSlide && track) {
            track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
          }
        }
      } catch(err) {}
    }

    connectedCallback() {
      new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }

    handleIntersection(entries, _observer) {
      if (!entries[0].isIntersecting) return;
      const selector = '.quick-view__content';
      const drawerContent = this.querySelector(selector);
      this.productUrl = this.dataset.productUrl
      this.sectionUrl = `${this.productUrl}&view=quick-view`;

      if (this._fetchController) {
        this._fetchController.abort();
      }
      this._fetchController = new AbortController();

      fetch(this.sectionUrl, { signal: this._fetchController.signal })
        .then(response => response.text())
        .then(responseText => {
          setTimeout(() => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector(selector);
            this.setInnerHTML(drawerContent, productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Initialize mobile bottom sheet swipe-to-dismiss
            this.initMobileSwipe();
          }, 1);

          document.body.classList.add('quick-view-load')

          setTimeout(() => {
            drawerContent.classList.add('hide-cover');

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productUrl: this.dataset.productUrl
              }
            }));
          }, 1);
        })
        .catch(e => {
          if (e.name !== 'AbortError') {
            console.error(e);
          }
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
      if (this.overlay) {
        this.overlay.classList.remove('is-closing');
        this.overlay.classList.add('open');
      }
      this.isClosing = false;

      // Initialize Carousel functionality
      const carousel = element.querySelector('.qv-carousel');
      if (carousel) {
        const track = carousel.querySelector('.qv-carousel__track');
        const prevBtn = carousel.querySelector('.qv-carousel__arrow--prev');
        const nextBtn = carousel.querySelector('.qv-carousel__arrow--next');
        const currentCounter = carousel.querySelector('.qv-counter-current');
        const slides = carousel.querySelectorAll('.qv-carousel__slide');

        if (track && slides.length > 1) {
          if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const slideWidth = track.clientWidth;
              if (track.scrollLeft <= 10) {
                track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
              } else {
                track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
              }
            });
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const slideWidth = track.clientWidth;
              if (track.scrollLeft + slideWidth >= track.scrollWidth - 10) {
                track.scrollTo({ left: 0, behavior: 'smooth' });
              } else {
                track.scrollBy({ left: slideWidth, behavior: 'smooth' });
              }
            });
          }

          if (currentCounter) {
            let scrollTimeout;
            track.addEventListener('scroll', () => {
              clearTimeout(scrollTimeout);
              scrollTimeout = setTimeout(() => {
                const slideWidth = track.clientWidth;
                if (slideWidth > 0) {
                  const currentIndex = Math.round(track.scrollLeft / slideWidth) + 1;
                  currentCounter.textContent = Math.min(Math.max(currentIndex, 1), slides.length);
                }
              }, 40);
            }, { passive: true });
          }
        }
      }

      // Handle variant image updates & carousel slide sync on option change
      const scrollToVariantMedia = () => {
        const mediaMapEl = element.querySelector('[id^="qv-variant-media-map-"]');
        const idInput = element.querySelector('input[name="id"]');
        const qvCarousel = element.querySelector('.qv-carousel');
        if (!mediaMapEl || !idInput || !idInput.value || !qvCarousel) return;

        try {
          const map = JSON.parse(mediaMapEl.textContent);
          const variantData = map[idInput.value];
          if (variantData && variantData.media_id) {
            const targetSlide = qvCarousel.querySelector(`[data-media-id="${variantData.media_id}"]`);
            const track = qvCarousel.querySelector('.qv-carousel__track');
            if (targetSlide && track) {
              track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
            }
          } else if (variantData && variantData.image_url) {
            const firstImg = qvCarousel.querySelector('.popup-product-img');
            if (firstImg) firstImg.src = variantData.image_url;
          }
        } catch(err) {}
      };

      element.addEventListener('change', (e) => {
        if (e.target && (e.target.type === 'radio' || e.target.tagName === 'SELECT')) {
          setTimeout(scrollToVariantMedia, 35);
        }
      });
    }

    initMobileSwipe() {
      if (window.innerWidth > 920) return;

      const popupWrapper = this.querySelector('.popup-wrapper__quick-view');
      if (!popupWrapper) return;

      let startX = 0;
      let startY = 0;
      let currentY = 0;
      let isDragging = false;

      const onTouchStart = (e) => {
        // Do not intercept swipe inside image carousel, buttons, or inputs
        if (e.target.closest('.qv-carousel') || e.target.closest('button') || e.target.closest('input') || e.target.closest('label')) return;
        const scrollArea = popupWrapper.querySelector('.scroll-area');
        if (scrollArea && scrollArea.scrollTop > 0) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        popupWrapper.style.transition = 'none';
      };

      const onTouchMove = (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        currentY = e.touches[0].clientY;
        const diffX = Math.abs(currentX - startX);
        const diffY = currentY - startY;
        // If horizontal motion is greater than vertical, let horizontal swipe proceed
        if (diffX > diffY) return;
        if (diffY > 0) {
          popupWrapper.style.transform = `translateY(${diffY}px)`;
          if (e.cancelable) e.preventDefault();
        }
      };

      const onTouchEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        const diff = currentY - startY;
        popupWrapper.style.transition = 'transform 0.35s cubic-bezier(0.16, 1, 0.3, 1)';
        if (diff > 120) {
          popupWrapper.style.transform = 'translateY(100%)';
          setTimeout(() => this.closeQuickView(true), 280);
        } else {
          popupWrapper.style.transform = 'translateY(0)';
        }
      };

      popupWrapper.addEventListener('touchstart', onTouchStart, { passive: true });
      popupWrapper.addEventListener('touchmove', onTouchMove, { passive: false });
      popupWrapper.addEventListener('touchend', onTouchEnd, { passive: true });
    }

    closeQuickView(immediate = false, keepOverlay = false) {
      if (this.isClosing) return;
      this.isClosing = true;

      const drawer = this.closest('quick-view-drawer') || document.querySelector('quick-view-drawer');
      const popupWrapper = this.querySelector('.popup-wrapper') || document.querySelector('.popup-wrapper__quick-view');
      const overlay = this.overlay || document.querySelector('body > .overlay');

      if (drawer) drawer.classList.add('is-closing');
      if (popupWrapper) popupWrapper.classList.add('is-closing');
      if (overlay && !keepOverlay) overlay.classList.add('is-closing');

      const finalize = () => {
        const drawerContent = this.querySelector('.quick-view__content');
        if (drawerContent) {
          drawerContent.innerHTML = '';
          drawerContent.classList.remove('hide-cover');
        }
        const cartDrawerActive = document.querySelector('cart-drawer.active') || document.querySelector('cart-notification.open') || keepOverlay;
        if (!cartDrawerActive) {
          this.closest('body').classList.remove('hidden');
          if (overlay) overlay.classList.remove('open');
          document.dispatchEvent(new CustomEvent('body:visible'));
        }
        this.closest('body').classList.remove('quick-view-open', 'quick-view-load');
        document.dispatchEvent(new CustomEvent('quickview:close'));
        const details = this.closest('details');
        if (details) details.removeAttribute('open');
        if (overlay) overlay.classList.remove('is-closing');
        if (drawer) drawer.classList.remove('is-closing');
        if (popupWrapper) popupWrapper.classList.remove('is-closing');
        this.isClosing = false;

        // Restore PDP buy buttons that may be stuck in loading state
        document.querySelectorAll('.main-product:not(.popup-wrapper__quick-view) .product-form__submit.loading').forEach(btn => {
          btn.classList.remove('loading');
          const spinner = btn.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
      };

      if (immediate) {
        finalize();
      } else {
        setTimeout(finalize, 450);
      }
    }
  }
  customElements.define('quick-view', QuickView);
